import { ADD_SECTION_TO_STUCTURE, REMOVE_SECTION_FROM_STUCTURE } from '../actions/structure';
import { DELETE_SECTION } from '../actions/sections';

export default (state = [], action) => {
  switch (action.type) {
  case ADD_SECTION_TO_STUCTURE: {
    const newState = state.slice(0);
    if (action.index === undefined) {
      newState.push(action.id);
    } else {
      newState.splice(action.index, 0, action.id);
    }
    return newState;
  }

  case REMOVE_SECTION_FROM_STUCTURE:
    return state.filter((id, index) => index !== action.index);

  case DELETE_SECTION: {
    return state.filter(id => id !== action.id);
  }
  default:
    return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/structure.js